export const mgPlatformArrowRightIcon = {
  data: `<svg viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 6.57143L1 12.1429" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-right'
}
